import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonalisationBook = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 28,
	viewBox: "0 0 23 28",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "inherit",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.00390625 3.97969C0.00390625 1.91333 1.67902 0.23822 3.74537 0.23822H18.2711C20.3374 0.23822 22.0125 1.91333 22.0125 3.97969V21.5866C22.0125 22.1943 21.5198 22.687 20.9121 22.687C20.3043 22.687 19.8117 22.1943 19.8117 21.5866V3.97969C19.8117 3.12883 19.1219 2.43908 18.2711 2.43908H3.74537C2.89452 2.43908 2.20477 3.12883 2.20477 3.97969V24.2276C2.20477 24.8354 1.71209 25.328 1.10434 25.328C0.496586 25.328 0.00390625 24.8354 0.00390625 24.2276V3.97969Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "inherit",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.52529 27.5289C1.58048 27.5289 0.00390625 25.9523 0.00390625 24.0075C0.00390625 22.0627 1.58048 20.4861 3.52529 20.4861H20.9121C21.5198 20.4861 22.0125 20.9788 22.0125 21.5865C22.0125 22.1943 21.5198 22.687 20.9121 22.687H3.52529C2.79598 22.687 2.20477 23.2782 2.20477 24.0075C2.20477 24.7368 2.79598 25.328 3.52529 25.328H20.9121C21.5198 25.328 22.0125 25.8207 22.0125 26.4284C22.0125 27.0362 21.5198 27.5289 20.9121 27.5289H3.52529Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "inherit",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.1512 20.9263C19.759 20.9263 20.2516 21.419 20.2516 22.0268V25.9883C20.2516 26.5961 19.759 27.0887 19.1512 27.0887C18.5435 27.0887 18.0508 26.5961 18.0508 25.9883V22.0268C18.0508 21.419 18.5435 20.9263 19.1512 20.9263Z"
		})
	]
});
export default SvgPersonalisationBook;
